import classNames from 'classnames';
import React from 'react';

import { RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { WarningIcon } from '@reverbdotcom/cadence/icons/react';

interface IProps {
  children: React.ReactNode;
  footerContent: React.ReactNode;
  errorText?: string;
}

export default function CarrierCalculatedDetailsBox({ children, footerContent, errorText }: IProps) {
  return (
    <div>
      <div
        className={classNames(
          'carrier-calculated-details-box',
          { 'carrier-calculated-details-box--error': !!errorText },
        )}
      >
        {children}

        <div
          className="carrier-calculated-details-box__footer"
        >
          {footerContent}
        </div>
      </div>

      {errorText && (
        <div className="carrier-calculated-details-box__error-text">
          <RCTextWithIcon
            svgComponent={WarningIcon}
            placement="left"
          >
            {errorText}
          </RCTextWithIcon>
        </div>
      )}
    </div>
  );
}
